export class LcgRandom {
  private state: number;
  private readonly m = 0x80000000;
  private readonly a = 1103515245;
  private readonly c = 12345;

  constructor(seed: number) {
    this.state = seed ? seed : Math.floor(Math.random() * (this.m - 1));
  }

  next(): number {
    this.state = (this.a * this.state + this.c) % this.m;
    return this.state / (this.m - 1);
  }

  nextInt(min: number, max: number): number {
    return Math.floor(this.next() * (max - min + 1)) + min;
  }

  pick<T>(array: T[]): T {
    return array[this.nextInt(0, array.length - 1)];
  }
}

export function generateId(rng: LcgRandom, prefix: string): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let id = prefix + '-';
  for (let i = 0; i < 6; i++) {
    id += chars[rng.nextInt(0, chars.length - 1)];
  }
  return id;
}

export function generateMac(rng: LcgRandom): string {
  const hex = '0123456789ABCDEF';
  let mac = '00:';
  for (let i = 0; i < 5; i++) {
    mac += hex[rng.nextInt(0, 15)] + hex[rng.nextInt(0, 15)];
    if (i < 4) mac += ':';
  }
  return mac;
}
